<template>
    <div class="justify-content-center row text-center mx-2 my-6 px-0 ">
        <div class="text-center w-100 display-money mb-5 mt-0   py-0">
            <input :value="formattedAmountBetting" type="text" inputmode="numeric" pattern="[0-9]*" id="betAmount"
                placeholder="ENTER BET AMOUNT" class="form-control text-center w-100 display-money my-0 pt-2"
                @keypress="handleKeyPress" @input="(event) => _inputAmount(event.target.value)" />
        </div>
        <div class="row ma-0 w-100 mx-auto text-center">
            <div class="row ma-0 px-1 ">
                <div v-for="(button, index) in passGetButton" :key="button._id" class=" ma-0 p-0 col-3 ">
                    <div @click="_inputCoinAmount(button.amount)" class="coin-slaga px-1">
                        <img :src="_detectCoin(index)" class="btn-coin text-center">
                        <div text :style="`color:${_detectColor(index)};`" class="text btn-bet-circle prevent-select"
                            style="    text-shadow: -1px 1px 0 #fff, 1px 1px 0 #fff, 1px -1px 0 #fff, -1px -1px 0 #fff;">
                            {{ button.label }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
export default {
    props: [
        'passGetButton',
        'passChannel',
        'passPlaceCoin',
    ],
    data() {
        return {
            selectedButton: {},
            colorBalance: 'bl_amount',

        }
    },
    computed: {

        ...mapGetters("$_modules", {
            userInfor: "getUserInfo",
        }),
        ...mapGetters("$_dashboard", {
            getAmountBetting: "getAmountBetting",
        }),
        formattedAmountBetting() {
            return this.getAmountBetting ? this.getAmountBetting.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '';
        }
    },
    methods: {
        _detectColor(index) {
            switch (index) {
                case 0:
                    return 'black';
                case 1:
                    return 'black';
                case 2:
                    return 'black';
                case 3:
                    return 'black';
                case 4:
                    return 'black';
                case 5:
                    return 'black';
                case 6:
                    return 'black';
                case 7:
                    return 'black';
                case 99:
                    return 'white';
                default:
                    return ''
            }
        },
        _detectCoin(index) {
            switch (index) {
                case 0:
                    return '/images/coins/blue.png';
                case 1:
                    return '/images/coins/pink.png';
                case 2:
                    return '/images/coins/green.png';
                case 3:
                    return '/images/coins/cyan.png';
                case 4:
                    return '/images/coins/orange.png';
                case 5:
                    return '/images/coins/red.png';
                case 6:
                    return '/images/coins/blue.png';
                case 7:
                    return '/images/coins/pink.png';
                case 33:
                    return '/images/coins/grey.png';
                default:
                    return ''
            }
        },
        handleKeyPress(event) {
            const charCode = event.charCode;
            if (
                !(charCode >= 48 && charCode <= 57)
            ) event.preventDefault();

          
        },
        _inputAmount(money) {
            // Remove commas and parse the number
            const parsedAmount = parseFloat(money.replace(/,/g, ''));
            if (!isNaN(parsedAmount)) {
                this.UPDATE_AMOUNT_BETTING(parsedAmount);
            } else {
                this.UPDATE_AMOUNT_BETTING(0); // Reset to 0 if not a valid number
            }
        },
        _inputCoinAmount(money) {
            let total_coin = 0;
            if (!this.getAmountBetting) total_coin = money;
            else total_coin = this.getAmountBetting + money
            this.UPDATE_AMOUNT_BETTING(total_coin)
        },

        formatCoinCurrency(amount) {
            switch (amount) {
                case 1000:
                    return '1ព';
                case 5000:
                    return '5ព';
                case 10000:
                    return '1ម';
                case 20000:
                    return '2ម';
                case 50000:
                    return '5ម';
                case 100000:
                    return '10ម';
                case 200000:
                    return '20ម';
                case 500000:
                    return '50ម';
                case 1000000:
                    return '1ល';
                case 5000000:
                    return '5ល';
                default:
                    return amount;
            }
        },
        formatBtnCurrencyKh(amount) {
            switch (true) {
                case (amount >= 1000 && amount <= 9999):
                    return amount / 1000 + "ព";
                case (amount >= 10000 && amount <= 999999):
                    return amount / 10000 + "ម";
                case (amount >= 1000000 && amount <= 99999999999):
                    return amount / 1000000 + "ល";
                default:
                    return amount
            }
        },
        formatBtnCurrency(amount) {
            switch (true) {
                case (amount >= 1000 && amount <= 9999):
                    return amount / 1000 + "K";
                default:
                    return amount
            }
        },
        formatMoney(amount) {
            return amount.toLocaleString("en");
        },
        ...mapMutations("$_dashboard", [
            "BETTING_DIALOG",
            "UPDATE_AMOUNT_BETTING"
        ]),
    }
}
</script>
<style scoped>
@media(max-width:760px) {
    .btn-coin {
        width: 100%;
        height: auto;
        position: relative;
        padding: 0.2rem;
        margin: 0px !important;
    }

    .btn-coin-cover:hover {
        cursor: pointer;
    }

    .btn-coin-cover {
        width: 100%
    }

    .btn-bet-circle {
        font-family: 'khmer mef1';
        position: absolute;
        font-size: 1rem;
        font-weight: 900;
        text-shadow: 1px 0px 1px black;
        width: 100%;
        top: 50%;
        left: 50%;
        transform: translate(-51%, -51%);
        padding: 0px;
        margin: 0px !important;
    }
}

@media(min-width:760px) {
    .btn-coin {
        width: 100%;
        height: auto;
        position: relative;
        padding: 0.25rem;
        margin: 0px !important;
    }

    .btn-coin-cover:hover {
        cursor: pointer;
    }

    .btn-bet-circle {
        font-family: 'khmer mef1';
        position: absolute;
        font-size: 1rem;
        font-weight: 900;
        text-shadow: 1px 0px 1px black;
        width: 100%;
        top: 50%;
        left: 50%;
        transform: translate(-51%, -51%);
        padding: 0px;
        margin: 0px !important;
    }
}

@media(min-width:960px) {
    .btn-coin {
        width: 100%;
        height: auto;
        position: relative;
        padding: 0.25rem;
        margin: 0px !important;
    }

    .btn-coin-cover:hover {
        cursor: pointer;
    }

    .btn-bet-circle {
        font-family: 'khmer mef1';
        position: absolute;
        font-size: 1rem;
        font-weight: 900;
        text-shadow: 1px 0px 1px black;
        width: 100%;
        top: 50%;
        left: 50%;
        transform: translate(-51%, -51%);
        padding: 0px;
        margin: 0px !important;
    }
}

@media(min-width:1280px) {
    .btn-coin {
        width: 100%;
        height: auto;
        position: relative;
        padding: 0.3rem;
        margin: 0px !important;
    }

    .btn-coin-cover:hover {
        cursor: pointer;
    }

    .money-in-coin-position {
        margin-top: -52px;
        margin-bottom: 25px;
        z-index: 100;
        font-weight: 900;
        font-size: 16px;
    }

    .btn-bet-circle {
        font-family: 'khmer mef1';
        position: absolute;
        font-size: 16px;
        font-weight: 900;
        text-shadow: 1px 1px 1px black;
        top: 50%;
        left: 50%;
        transform: translate(-51%, -51%);
        padding: 0px;
        margin: 0px !important;
    }
}

.prevent-select {
    -webkit-user-select: none;
    /* Safari */
    -ms-user-select: none;
    /* IE 10 and IE 11 */
    user-select: none;
    /* Standard syntax */
}

.hold-coin {
    position: sticky;
    left: 0px;
    z-index: 100;
    background: #013366;
    font-size: bolder;
    border-right: 2px dashed white;
}

.coin-container {
    overflow: auto;
    flex-wrap: nowrap;
    width: 100%;
}

.coin-container:hover {
    cursor: pointer;
}

.display-money {
    background: rgba(255, 255, 255, 0.9);
    height: 40px;
    border-radius: 5px;
    margin: 5px 0px 7px 0px;
    color: black !important;
    font-weight: bolder;
    text-shadow: 1px 0.2px #406386;
    font-size: 1.3rem;
    padding-top: 5px;

}

.coin-slaga:hover {
    cursor: pointer;
}

.btn-coin {
    filter: drop-shadow(0px 0px 3px #395089);
}
</style>